// sagas.js
import { call, put, takeEvery, take, } from 'redux-saga/effects';
import {
  FETCH_DAILY_REPORTS_REQUEST,
  FETCH_DAILY_REPORT_REQUEST,
  FETCH_REPORT_TECHNICIAN_REQUEST,
  FETCH_REPORT_STATUS_REQUEST,

  fetchDailyReportsSuccess,
  fetchDailyReportSuccess,
  fetchReportTechnicianSuccess,
  fetchReportStatusSuccess,

  fetchDailyReportsFailure,
  fetchDailyReportFailure,
  fetchReportTechnicianFailure,
  fetchReportStatusFailure,
} from './actions';
import { api } from '../../api';

function* fetchDailyReportsSaga(action) {
  try {
    const response = yield call(api.getReports, action.payload); // Pass the function and the args 
    yield put(fetchDailyReportsSuccess(response.data));
  } catch (error) {
    yield put(fetchDailyReportsFailure(error.message));
  }
}

function* fetchDailyReportSaga(action) {
  console.log('data daily payload', action.payload);
  try {
    const response = yield call(api.getDailyReport,action.payload); // Pass the function and the args 
    yield put(fetchDailyReportSuccess(response.data));
  } catch (error) {
    yield put(fetchDailyReportFailure(error.message));
  }
}

function* fetchReportTechnicianSaga(action) {
  try {
    const response = yield call(api.getReportTechnician, action.payload); // Pass the function and the args 
    yield put(fetchReportTechnicianSuccess(response.data));
  } catch (error) {
    yield put(fetchReportTechnicianFailure(error.message));
  }
}

function* fetchReportStatusSaga(action) {
  try {
    const response = yield call(api.getReportStatus, action.payload); // Pass the function and the args 
    yield put(fetchReportStatusSuccess(response.data));
  } catch (error) {
    yield put(fetchReportStatusFailure(error.message));
  }
}

export function* watchFetchDailyReports() {
  yield takeEvery(FETCH_DAILY_REPORTS_REQUEST, fetchDailyReportsSaga);
}

export function* watchFetchDailyReport() {
  yield takeEvery(FETCH_DAILY_REPORT_REQUEST, fetchDailyReportSaga);
}

export function* watchFetchReportTechnician() {
  yield takeEvery(FETCH_REPORT_TECHNICIAN_REQUEST, fetchReportTechnicianSaga);
}

export function* watchFetchReportStatus() {
  yield takeEvery(FETCH_REPORT_STATUS_REQUEST, fetchReportStatusSaga);
}
